import { SEARCH_DEBOUNCE_MS } from "@/constants/config";
import { useEffect, useState } from "react";

/** Debounced mirror of a fast-changing value (search inputs). */
export const useDebouncedValue = <T>(value: T, delay = SEARCH_DEBOUNCE_MS): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeout = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(timeout);
  }, [value, delay]);

  return debounced;
};
